import { createFileRoute } from "@tanstack/react-router";
import WorkflowNodeCatalogPage from "@/features/workflows/workflow-node-catalog-page";
import { requireFeatureEnabled } from "@/features/features";

export const Route = createFileRoute("/_admin/workflows/catalog")({
  beforeLoad: () => requireFeatureEnabled("workflows"),
  component: WorkflowNodeCatalogPage,
});
